export const flashdata = [
  {
    id: 1,
    title: "Shockproof Clear Phone Case For Iphone 6 plus...",
    imageurl:
      "https://static-01.daraz.com.np/p/a72935c61263269def0e09c29a2c913a.jpg",
    price: "Rs. 189",
    expectprice: "Rs. 299",
    discount: "-36%",
  },
  {
    id: 2,
    title: "Zamz Genuine 100% Leather Wallet For Men",
    imageurl:
      "https://static-01.daraz.com.np/p/ed4ea23aa4e06d6fda46b0ebc37f24e3.jpg",
    price: "Rs. 445",
    expectprice: "Rs. 489",
    discount: "-9%",
  },
  {
    id: 3,
    title: "Lcd Writing Tablet 8.5 Inch Electronic Writing... ",
    imageurl:
      "https://static-01.daraz.com.np/p/790684bd9c3c3ab63f2152de8fbc0966.jpg",
    price: "Rs. 274",
    expectprice: "Rs. 1000",
    discount: "-73%",
  },
  {
    id: 4,
    title: "19 In One Nail Clipper Set Nails Manciure Tools ",
    imageurl:
      "https://static-01.daraz.com.np/p/5d7049f339f38cd80fb12d47c909bd97.jpg",
    price: "Rs. 569",
    expectprice: "Rs. 1000",
    discount: "-43%",
  },
  {
    id: 5,
    title: "L11 Razer Gaming MousePad - 25cm",
    imageurl:
      "https://static-01.daraz.com.np/p/480a06794a9a5368235d809f78d9c1ee.jpg",
    price: "Rs. 145",
    expectprice: "Rs. 200",
    discount: "-28%",
  },
  {
    id: 6,
    title: "Pebbles Nepal 18 Pairs Viral Earrings Set For...",
    imageurl:
      "https://static-01.daraz.com.np/p/4bb68b20785d7025b97dec62b195cd60.png",
    price: "Rs. 568",
    expectprice: "Rs. 999",
    discount: "-43%",
  },
  // {
  //     id : 7,
  //     title:"Round Silver Frame Black Lens Sunglasses For Men",
  //     imageurl:"https://static-01.daraz.com.np/p/8c5acaef1474b9d08d90aed9320053fa.jpg",
  //     price:"Rs. 720",
  //     expectprice:"Rs. 1500",
  //     discount:"-53%",

  // },
  // {
  //     id : 8,
  //     title:"Nacked Dialed Fashionable Designed Analog Watch F...",
  //     imageurl:"https://static-01.daraz.com.np/p/e2f99a569b54ede8963edd84e851fd0b.jpg",
  //     price:"Rs. 450",
  //     expectprice:"Rs. 650",
  //     discount:"-30%",

  // },
  // {
  //     id : 9,
  //     title:"New Retro Rectangular Premium Sunglasses For...",
  //     imageurl:"https://static-01.daraz.com.np/p/1b1428a7478c03e256279a77ebf18042.jpg",
  //     price:"Rs. 439",
  //     expectprice:"Rs. 1200",
  //     discount:"-63%",

  // },
  // {
  //     id : 10,
  //     title:"Dancing Cactus Funny Talk-Back",
  //     imageurl:"https://static-01.daraz.com.np/p/823defd4016731c2191bb82858776436.jpg",
  //     price:"Rs. 760",
  //     expectprice:"Rs. 866",
  //     discount:"-13%",

  // },
  // {
  //     id : 11,
  //     title:"Minecraft Tshirt for Kids",
  //     imageurl:"https://static-01.daraz.com.np/p/7d4f8832fe0008af24c6add73dbd8865.jpg",
  //     price:"Rs. 499",
  //     expectprice:"Rs. 750",
  //     discount:"-33%",

  // },
  // {
  //     id : 12,
  //     title:"Kitchen Sticker Oil Proof Waterproof Paper...",
  //     imageurl:"https://static-01.daraz.com.np/p/b26adec2c3676d4d852ca8d8ce41baba.jpg",
  //     price:"Rs. 300",
  //     expectprice:"Rs. 500",
  //     discount:"-40%",

  // },
];